import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() btnOkText: string = '';
  @Input() btnCancelText: string = '';
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  close(data?: any): void {
    this.onClose.emit(data);
  }

  Confirm() {
    this.onClose.emit(true);
  }

  Cancel() {
    this.onClose.emit(false);
  }
}
